import { render, staticRenderFns } from "./UpdateYourPlan.vue?vue&type=template&id=062a60ea&scoped=true&"
import script from "./UpdateYourPlan.vue?vue&type=script&lang=js&"
export * from "./UpdateYourPlan.vue?vue&type=script&lang=js&"
import style0 from "./UpdateYourPlan.vue?vue&type=style&index=0&id=062a60ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062a60ea",
  null
  
)

export default component.exports